import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormGroup, InputGroup, FormControl, SplitButton, MenuItem, DropdownButton, Button, ControlLabel } from "react-bootstrap";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import Modal from "react-responsive-modal";
import request from "superagent";
import { copy, isClipboardEmpty, getClipboard } from "../../utils/clipboard";
import autoBind from "react-autobind";
import _ from "lodash";

import {
	isDriveReference,
	getDriveObject,
	getUrlForResource,
	getResourceReference,
	uploadAndOptimizeMediaFile,
	setActiveTreeCursor,
	uploadFile,
	getDriveObjectByPath,
	listDrive,
	setActiveTreeCursorForDriveGuid,
	getFullObjectPath/*, getContent*/
} from "../../actions/drive";
import { showSuccess, showConfirm } from "../../actions/alertActions";
import InlineFilePicker from "../drive/inlineFilePicker";
import { injectExternalResourceReference, getDriveObjectForReference, getDriveRootPath, isMediaOptimizationDisabled } from "../../actions/activityActions";
import { handleChangeProperty, getSelectedNodePath, handleShowGenerateTtsAudioForPropertyModal, showMediaPreviewModal } from "../../actions/actions";
import { refreshCredentials, urlToSecureParameterObject } from "../../utils/securityUtil";
import { isMobile, isAiAssistantEnabled, /*, fixFileNameForS3*/ } from "../../utils/utils";
import { showError } from "../../actions/alertActions";
import { AmbifiLoader } from ".";
import { generateUUID, generatePastedImageFileName } from "../../utils/utils";
import PasteImageModal from "./pasteImageModal";
import AiImageGeneratorModal from "./aiImageGeneratorModal";
import MarkupImageModal from "../markupImage/MarkupImageModal";
import VideoThumbnailModal from "./videoThumbnailModal";
import ImageEditorModal from "./imageEditorModal";
import { launchAiAssistant } from "../../ai/assistantLaunch";
import state from "../../state/state";
import env from "../../constants/env";
import { getOrgId } from "../../actions/orgsActions";
import { getJwtToken } from "../../actions/user";
import {
	getAudioTranscriptionsLambda,
	getAwsTranscribeLambda,
	getImageDescriptionsLambda,
	getPdfResponsesLambda,
	getRekognitionTagsLambda,
	getResponsesCreateLambda
} from "../../ai/aiAssistant";
import { getMediaType } from "../../utils/mediaUtils";

import ImageWithMarkup from "./imageWithMarkup";

const MAX_METADATA_TITLE_CHARS = 120;
const MAX_METADATA_DESCRIPTION_CHARS = 600;
const MAX_METADATA_TRANSCRIPT_CHARS = 20000;
const MAX_METADATA_TRANSCRIPT_VTT_CHARS = 250000;
const TRANSCRIPT_PROVIDER_OPENAI = "openai";
const TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE = "aws-transcribe";
const TAGS_PROVIDER_OPENAI = "openai";
const TAGS_PROVIDER_REKOGNITION = "rekognition";

class MediaPropertyInjector extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			previewUrl: null,
			mobile: isMobile(),
			uploading: false,
			showPasteImageModal: false,
			showAiImageGeneratorModal: false,
			showMarkupImageModal: false,
			showImageEditorModal: false,
			imageEditorTargetPropName: null,
			showVideoThumbnailModal: false,
			videoThumbnailTargetPropName: null,
			showMediaMetadataPanel: false,
			showPreviewMetadataTitle: true,
			showPreviewMetadataDescription: false,
			showPreviewMetadataTags: false,
			showMetadataEditorModal: false,
			metadataEditorSaving: false,
			metadataEditorTarget: null,
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataEditorPrimaryTags: [],
			metadataEditorSecondaryTags: [],
			metadataEditorTagsInput: "",
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		};
		this.fileUploadField = React.createRef();
		autoBind(this);
	}

	handleSwitchMode(mode) {
		if (this.props.onValueChange) {
			if (mode === "drive") {
				this.props.onValueChange(getResourceReference(null));
			} else {
				this.props.onValueChange("https://");
			}
		}
	}

	isAiAssistantUiEnabled() {
		return isAiAssistantEnabled(this.props.urlParams || {});
	}

	isImageToolsEnabled() {
		const urlFlag = _.get(this.props, "urlParams.imageTools");
		if (urlFlag === true || urlFlag === "true" || urlFlag === 1 || urlFlag === "1") {
			return true;
		}

		if (typeof window !== "undefined" && window.location) {
			const localHostnames = ["localhost", "127.0.0.1", "local.ambifi.com", "::1"];
			return localHostnames.includes(window.location.hostname);
		}

		return false;
	}

	handleDeleteMediaProperty() {
		showConfirm("Are you sure you want to delete this media item?", "Delete Media", () => {
			this.props.onValueChange("");
		});
	}

	handleSelectFile(info) {
		console.log(info);
		const { propName } = this.props;
		injectExternalResourceReference(propName, info, getSelectedNodePath(), this.props.onChange);
		this.syncDriveSelectionForAssistant(info);
		this.setState({
			showMediaMetadataPanel: false
		});
	}

	getSelectedNodeEntity() {
		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || !selectedNodePath.length) {
			return null;
		}

		const selectedNode = state.get(selectedNodePath);
		if (!selectedNode || !selectedNode.entity) {
			return null;
		}

		return selectedNode.entity;
	}

	getAssociatedVideoThumbnailSource() {
		const entity = this.getSelectedNodeEntity();
		if (!entity || !entity.video) {
			return null;
		}

		const videoValue = entity.video;
		const label = entity.label || entity.title || entity.name || "video-thumbnail";
		const defaultBaseName = `${label}-thumbnail`;

		if (_.isString(videoValue)) {
			return {
				url: videoValue,
				label,
				defaultBaseName
			};
		}

		if (!isDriveReference(videoValue)) {
			return null;
		}

		try {
			const resource = getDriveObjectForReference(videoValue);
			if (!resource) {
				return null;
			}

			return {
				url: getUrlForResource(resource),
				label: resource.name || label,
				defaultBaseName
			};
		} catch (err) {
			console.warn(err);
			return null;
		}
	}

	canCreateVideoThumbnail() {
		return !!this.getAssociatedVideoThumbnailSource();
	}

	getCurrentImageEditorSource() {
		const imageValue = this.props.value;
		if (!imageValue) {
			return null;
		}

		const entity = this.getSelectedNodeEntity();
		const label = _.trim(_.get(entity, "label", "") || _.get(entity, "title", "") || _.get(entity, "name", ""));
		const fallbackBaseName = label !== "" ? `${label}-edited` : "image-edited";

		if (_.isString(imageValue)) {
			return {
				url: imageValue,
				label: label || imageValue,
				defaultBaseName: fallbackBaseName,
				resource: null,
				originalImageName: _.last(`${imageValue}`.split("/")) || "image.png",
				overwriteTargetPath: ""
			};
		}

		if (!isDriveReference(imageValue)) {
			return null;
		}

		try {
			const resource = getDriveObjectForReference(imageValue);
			if (!resource) {
				return null;
			}

			const resourcePath = this.getDriveResourcePath(resource);
			const resourceFileName = _.last(`${resourcePath || ""}`.split("/")) || "";
			const resourceName = resource.name || label || "image";
			const resourceStem = `${resourceName}`.replace(/\.[^/.]+$/, "") || "image";

			return {
				url: getUrlForResource(resource),
				label: resourceName,
				defaultBaseName: `${resourceStem}-edited`,
				resource,
				driveObjectGuid: resource.guid || null,
				originalImageName: resourceFileName || resource.name || `${resourceStem}.png`,
				overwriteTargetPath: resourcePath
			};
		} catch (err) {
			console.warn(err);
			return null;
		}
	}

	canEditCurrentImage() {
		return !!this.getCurrentImageEditorSource();
	}

	getDriveResourceFromValue(value = this.props.value) {
		if (!isDriveReference(value)) {
			return null;
		}

		try {
			return getDriveObjectForReference(value);
		} catch (err) {
			console.warn(err);
			return null;
		}
	}

	getDriveResourcePath(resource = null) {
		const target = resource || {};
		if (typeof target.path === "string" && target.path.trim() !== "") {
			return target.path.trim();
		}
		if (Array.isArray(target.path) && target.path.length > 0) {
			return target.path.join("/");
		}
		if (typeof target.fullPath === "string" && target.fullPath.trim() !== "") {
			return target.fullPath.trim();
		}
		return "";
	}

	resolveDriveSelectionResource(resource = null) {
		const target = resource || this.getDriveResourceFromValue();
		if (!target || target.type === "folder") {
			return null;
		}
		if (target.guid) {
			return target;
		}

		const targetPath = this.getDriveResourcePath(target);
		if (!targetPath) {
			return target;
		}

		const lookedUp = getDriveObjectByPath(targetPath, this.props.propName === "video");
		if (lookedUp && lookedUp.type !== "folder") {
			return {
				...target,
				...lookedUp
			};
		}

		return target;
	}

	syncDriveSelectionForAssistant(resource = null) {
		const nextResource = this.resolveDriveSelectionResource(resource);
		if (!nextResource) {
			return;
		}

		setActiveTreeCursor(nextResource);
	}

	handleUseInAiAssistant(resource = null, prefillQuestion = "") {
		if (!this.isAiAssistantUiEnabled()) {
			showError("AI Assistant", "Enable AI Assistant first (dev or ?aiAssistant=true).");
			return;
		}

		const nextResource = this.resolveDriveSelectionResource(resource);
		if (!nextResource) {
			showError("AI Assistant", "Select a Drive file first.");
			return;
		}

		this.syncDriveSelectionForAssistant(nextResource);
		const launchRequest = launchAiAssistant({
			mode: "drive_asset",
			preferredPanelMode: "side",
			prefillQuestion
		});
		// Fallback if centralized launch helper is feature-gated in this environment.
		if (!launchRequest) {
			state.set(["appState", "aiAssistantLaunchRequest"], {
				requestId: `${Date.now()}-drive-asset-launch`,
				mode: "drive_asset",
				prefillQuestion,
				preferredPanelMode: "side",
				targetPath: null,
				targetLabel: "",
				targetFieldType: "",
				responseFormat: "",
				targetReadOnly: false,
				featureName: "",
				featureDescription: "",
				additionalContextLines: [],
				autoRun: false
			});
		}
		setTimeout(() => {
			this.scrollAssistantIntoView();
		}, 120);
	}

	scrollAssistantIntoView() {
		if (typeof document === "undefined") {
			return;
		}
		const assistantRoot =
			document.getElementById("app-ai-assistant-root") ||
			document.querySelector("[data-ai-assistant-root='true']");
		if (assistantRoot && typeof assistantRoot.scrollIntoView === "function") {
			assistantRoot.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			});
		}
	}

	handleShowMetadataEditor(resource = null) {
		const nextResource = this.resolveDriveSelectionResource(resource);
		if (!nextResource) {
			showError("Metadata", "Select a Drive file first.");
			return;
		}

		const metaData = nextResource && nextResource.metaData && typeof nextResource.metaData === "object"
			? nextResource.metaData
			: {};
		const primaryTags = this.mergeUniqueMetadataTags(this.normalizeMetadataTagSource(metaData.tags));
		const secondaryTags = this.mergeUniqueMetadataTags([
			...this.normalizeMetadataTagSource(metaData.rekognitionTags),
			...this.normalizeMetadataTagSource(metaData.openAiTags),
			...this.normalizeMetadataTagSource(metaData.labels),
			...this.normalizeMetadataTagSource(nextResource.labels)
		]).filter((tag) => !primaryTags.map((entry) => entry.toLowerCase()).includes(tag.toLowerCase()));

		this.setState({
			showMetadataEditorModal: true,
			metadataEditorSaving: false,
			metadataEditorTarget: nextResource,
			metadataEditorTitle: this.cleanMetadataTitle(metaData.title || ""),
			metadataEditorDescription: this.cleanMetadataDescription(metaData.description || ""),
			metadataEditorTranscript: this.cleanMetadataTranscript(metaData.transcript || ""),
			metadataEditorTranscriptVtt: this.cleanMetadataTranscriptVtt(metaData.transcriptVtt || ""),
			metadataEditorPrimaryTags: primaryTags,
			metadataEditorSecondaryTags: secondaryTags,
			metadataEditorTagsInput: "",
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		});
	}

	handleHideMetadataEditor() {
		this.setState({
			showMetadataEditorModal: false,
			metadataEditorSaving: false,
			metadataEditorTarget: null,
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataEditorPrimaryTags: [],
			metadataEditorSecondaryTags: [],
			metadataEditorTagsInput: "",
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_OPENAI,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		});
	}

	handleMetadataEditorTitleChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTitle: rawValue.slice(0, MAX_METADATA_TITLE_CHARS)
		});
	}

	handleMetadataEditorDescriptionChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorDescription: rawValue.slice(0, MAX_METADATA_DESCRIPTION_CHARS)
		});
	}

	handleMetadataEditorTranscriptChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscript: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_CHARS)
		});
	}

	handleMetadataEditorTranscriptVttChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscriptVtt: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS)
		});
	}

	handleMetadataEditorTagsInputChange(event) {
		this.setState({
			metadataEditorTagsInput: event?.target?.value || ""
		});
	}

	handleAddMetadataEditorInputTags() {
		const inputTags = this.normalizeMetadataTagSource(this.state.metadataEditorTagsInput);
		if (!inputTags.length) {
			return;
		}
		this.setState((prev) => ({
			metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([
				...(prev.metadataEditorPrimaryTags || []),
				...inputTags
			]),
			metadataEditorTagsInput: ""
		}));
	}

	handleRemoveMetadataEditorPrimaryTag(tagToRemove) {
		this.setState((prev) => ({
			metadataEditorPrimaryTags: (prev.metadataEditorPrimaryTags || []).filter((tag) => {
				return `${tag}`.toLowerCase() !== `${tagToRemove}`.toLowerCase();
			})
		}));
	}

	handlePromoteMetadataEditorSecondaryTag(tagToPromote) {
		this.setState((prev) => ({
			metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([
				...(prev.metadataEditorPrimaryTags || []),
				tagToPromote
			]),
			metadataEditorSecondaryTags: (prev.metadataEditorSecondaryTags || []).filter((tag) => {
				return `${tag}`.toLowerCase() !== `${tagToPromote}`.toLowerCase();
			})
		}));
	}

	handlePromoteAllMetadataEditorSecondaryTags() {
		this.setState((prev) => ({
			metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([
				...(prev.metadataEditorPrimaryTags || []),
				...(prev.metadataEditorSecondaryTags || [])
			]),
			metadataEditorSecondaryTags: []
		}));
	}

	handleMetadataTranscriptProviderChange(event) {
		this.setState({ metadataTranscriptProvider: event?.target?.value || TRANSCRIPT_PROVIDER_OPENAI });
	}

	handleMetadataTagsProviderChange(event) {
		this.setState({ metadataTagsProvider: event?.target?.value || TAGS_PROVIDER_OPENAI });
	}

	async handleGenerateMetadataTitle() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target) {
			showError("Metadata", "Select a file before generating a title.");
			return;
		}

		this.setState({ metadataGeneratingField: "title" });
		try {
			const prompt = [
				"You are generating metadata for a Drive asset.",
				"Return only a concise title (no label, no quotes, no markdown), max 120 characters.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const title = this.cleanMetadataTitle(responseText);
			if (!title) {
				throw new Error("Generation returned an empty title.");
			}
			this.setState({ metadataEditorTitle: title });
		} catch (err) {
			showError("Generate Title", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataDescription() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target) {
			showError("Metadata", "Select a file before generating a description.");
			return;
		}

		this.setState({ metadataGeneratingField: "description" });
		try {
			const prompt = [
				"You are generating metadata for a Drive asset.",
				"Return only one concise description for search/discovery, max 600 characters.",
				"No markdown, no headings, no source citations.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const description = this.cleanMetadataDescription(responseText);
			if (!description) {
				throw new Error("Generation returned an empty description.");
			}
			this.setState({ metadataEditorDescription: description });
		} catch (err) {
			showError("Generate Description", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscript() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const { metadataTranscriptProvider } = this.state;
		if (!target) {
			showError("Metadata", "Select a file before generating transcript/content text.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcript" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			const s3Key = this.getMetadataResourceS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				if (mediaType !== "audio" && mediaType !== "video") {
					throw new Error("AWS Transcribe generation is only supported for audio/video files.");
				}
				const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					response_format: "text"
				}), { showAlert: false });
				let transcriptText = this.cleanMetadataTranscript(this.extractAwsTranscribeText(awsResponse));
				const transcriptVtt = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
				if (!transcriptText && transcriptVtt) {
					transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
				}
				if (!transcriptText) {
					throw new Error("AWS Transcribe returned empty transcript.");
				}
				this.setState({
					metadataEditorTranscript: transcriptText,
					...(transcriptVtt ? { metadataEditorTranscriptVtt: transcriptVtt } : {})
				});
				return;
			}

			let transcriptText = "";
			if (mediaType === "audio" || mediaType === "video") {
				const response = await getAudioTranscriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: `Transcribe this ${mediaType} into plain text with useful section breaks.`
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "image") {
				const response = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: "Describe this image in plain text for accessibility and search."
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "pdf") {
				const response = await getPdfResponsesLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					model: "gpt-5.4",
					prompt: "Summarize this selected PDF into clean, practical sections for searchable content metadata."
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else {
				const prompt = [
					"You are generating a long-form content text field for a Drive asset.",
					"For non-audio/video files, produce a concise content representation based on available metadata.",
					"No markdown tables. No source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				transcriptText = await this.runMetadataResponsesPrompt(prompt);
			}

			const cleanedTranscript = this.cleanMetadataTranscript(transcriptText);
			if (!cleanedTranscript) {
				throw new Error("Generation returned empty transcript/content text.");
			}
			this.setState({ metadataEditorTranscript: cleanedTranscript });
		} catch (err) {
			showError("Generate Transcript", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscriptVtt() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const { metadataTranscriptProvider } = this.state;
		if (!target) {
			showError("Generate VTT", "Select a file before generating timed transcript.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcriptVtt" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			if (mediaType !== "audio" && mediaType !== "video") {
				throw new Error("Timed transcript (VTT) is currently only supported for audio/video files.");
			}

			const s3Key = this.getMetadataResourceS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					response_format: "vtt"
				}), { showAlert: false });
				let vttText = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
				if (!vttText) {
					vttText = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeText(awsResponse));
				}
				if (!vttText || !/-->/m.test(vttText)) {
					throw new Error("AWS Transcribe did not return valid VTT timestamp cues.");
				}
				this.setState({ metadataEditorTranscriptVtt: vttText });
				return;
			}

			const response = await getAudioTranscriptionsLambda(JSON.stringify({
				bucket: env.s3.assetsBucket,
				key: s3Key,
				fileName: target.name || "",
				mediaType,
				model: "whisper-1",
				response_format: "vtt"
			}), { showAlert: false });

			const rawVtt = this.extractResponsesText(response);
			if (!/-->/m.test(`${rawVtt || ""}`)) {
				throw new Error("VTT output did not include timestamp cues.");
			}
			const cleanedVtt = this.cleanMetadataTranscriptVtt(rawVtt);
			if (!cleanedVtt) {
				throw new Error("Generation returned empty VTT content.");
			}
			this.setState({ metadataEditorTranscriptVtt: cleanedVtt });
		} catch (err) {
			showError("Generate VTT", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTags() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const { metadataTagsProvider } = this.state;
		if (!target) {
			showError("Metadata", "Select a file before generating tags.");
			return;
		}

		this.setState({ metadataGeneratingField: "tags" });
		try {
			if (metadataTagsProvider === TAGS_PROVIDER_REKOGNITION) {
				const s3Key = this.getMetadataResourceS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}
				const rekognitionResponse = await getRekognitionTagsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					maxLabels: 25,
					minConfidence: 70
				}), { showAlert: false });
				const generatedTags = this.extractTagsFromRekognitionPayload(rekognitionResponse);
				if (!generatedTags.length) {
					throw new Error("No Rekognition tags generated.");
				}
				this.setState((prev) => ({
					metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([...(prev.metadataEditorPrimaryTags || []), ...generatedTags])
				}));
				return;
			}

			const prompt = [
				"You are generating searchable tags for a Drive asset.",
				"Return only one comma-separated line of tags (no bullets, no explanations).",
				"Use short phrases. Max 15 tags.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const generatedTags = this.parseGeneratedTags(responseText);
			if (!generatedTags.length) {
				throw new Error("Generation returned no tags.");
			}
			this.setState((prev) => ({
				metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([...(prev.metadataEditorPrimaryTags || []), ...generatedTags])
			}));
		} catch (err) {
			showError("Generate Tags", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleSaveMetadataEditor() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target) {
			showError("Metadata", "Select a Drive file first.");
			return;
		}

		const path = this.getDriveResourcePath(target);
		if (!path) {
			showError("Metadata", "Unable to save metadata because file path is missing.");
			return;
		}

		const metaData = target.metaData && typeof target.metaData === "object"
			? _.cloneDeep(target.metaData)
			: {};
		const title = this.cleanMetadataTitle(this.state.metadataEditorTitle);
		const description = this.cleanMetadataDescription(this.state.metadataEditorDescription);
		const transcript = this.cleanMetadataTranscript(this.state.metadataEditorTranscript);
		const transcriptVtt = this.cleanMetadataTranscriptVtt(this.state.metadataEditorTranscriptVtt);
		const tags = this.mergeUniqueMetadataTags(this.state.metadataEditorPrimaryTags || []);

		metaData.tags = tags;
		if (title) {
			metaData.title = title;
		} else {
			delete metaData.title;
		}
		if (description) {
			metaData.description = description;
		} else {
			delete metaData.description;
		}
		if (transcript) {
			metaData.transcript = transcript;
		} else {
			delete metaData.transcript;
		}
		if (transcriptVtt) {
			metaData.transcriptVtt = transcriptVtt;
		} else {
			delete metaData.transcriptVtt;
		}

		this.setState({ metadataEditorSaving: true });

		try {
			await refreshCredentials();
			await request
				.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId: getOrgId(),
					path: getFullObjectPath(path),
					metaData
				}));

			await listDrive(true);
			if (target.guid) {
				setActiveTreeCursorForDriveGuid(target.guid);
			} else {
				setActiveTreeCursor({
					...target,
					metaData
				});
			}

			showSuccess("Metadata", "Metadata saved.");
			this.setState({
				metadataEditorSaving: false,
				showMetadataEditorModal: false,
				metadataEditorTarget: {
					...target,
					metaData
				}
			});
		} catch (err) {
			console.error(err);
			showError("Metadata", `Failed to save metadata: ${err?.message || err}`);
			this.setState({ metadataEditorSaving: false });
		}
	}

	handleToggleMediaMetadataPanel() {
		this.setState((prev) => ({
			showMediaMetadataPanel: !prev.showMediaMetadataPanel
		}));
	}

	handleTogglePreviewMetadataField(field) {
		const fieldToStateKey = {
			title: "showPreviewMetadataTitle",
			description: "showPreviewMetadataDescription",
			tags: "showPreviewMetadataTags"
		};
		const stateKey = fieldToStateKey[field];
		if (!stateKey) {
			return;
		}
		this.setState((prev) => ({
			[stateKey]: !prev[stateKey]
		}));
	}

	cleanMetadataText(value) {
		if (typeof value !== "string") {
			return "";
		}
		return value.trim();
	}

	normalizeMetadataTagSource(source) {
		if (!source) {
			return [];
		}
		if (Array.isArray(source)) {
			return source.map((entry) => {
				if (typeof entry === "string") {
					return entry.trim();
				}
				if (entry && typeof entry === "object") {
					const value = entry.label || entry.name || entry.Name || entry.tag || entry.Tag;
					return typeof value === "string" ? value.trim() : "";
				}
				return "";
			}).filter(Boolean);
		}
		if (typeof source === "string") {
			return source
				.split(",")
				.map((entry) => entry.trim())
				.filter(Boolean);
		}
		if (source && typeof source === "object") {
			return Object.keys(source)
				.map((entry) => `${entry}`.trim())
				.filter(Boolean);
		}
		return [];
	}

	mergeUniqueMetadataTags(tags = []) {
		const seen = {};
		const unique = [];
		tags.forEach((tag) => {
			const normalized = `${tag || ""}`.trim();
			if (!normalized) {
				return;
			}
			const key = normalized.toLowerCase();
			if (seen[key]) {
				return;
			}
			seen[key] = true;
			unique.push(normalized);
		});
		return unique;
	}

	getMediaMetadataForResource(resource = null) {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object"
			? resource.metaData
			: {};
		const title = this.cleanMetadataText(metaData.title || "");
		const description = this.cleanMetadataText(metaData.description || "");
		const tags = this.mergeUniqueMetadataTags([
			...this.normalizeMetadataTagSource(metaData.tags),
			...this.normalizeMetadataTagSource(resource?.labels),
			...this.normalizeMetadataTagSource(metaData.openAiTags),
			...this.normalizeMetadataTagSource(metaData.rekognitionTags),
			...this.normalizeMetadataTagSource(metaData.labels),
			...this.normalizeMetadataTagSource(resource?.tags)
		]);

		return { title, description, tags };
	}

	hasAnyMediaMetadata(mediaMetadata = null) {
		if (!mediaMetadata) {
			return false;
		}
		return !!(
			mediaMetadata.title ||
			mediaMetadata.description ||
			(Array.isArray(mediaMetadata.tags) && mediaMetadata.tags.length > 0)
		);
	}

	cleanMetadataTitle(value) {
		const cleaned = this.cleanMetadataText(value);
		return cleaned.length > MAX_METADATA_TITLE_CHARS ? cleaned.slice(0, MAX_METADATA_TITLE_CHARS).trim() : cleaned;
	}

	cleanMetadataDescription(value) {
		const cleaned = this.cleanMetadataText(value);
		return cleaned.length > MAX_METADATA_DESCRIPTION_CHARS ? cleaned.slice(0, MAX_METADATA_DESCRIPTION_CHARS).trim() : cleaned;
	}

	cleanMetadataTranscript(value) {
		const cleaned = this.cleanMetadataText(value);
		return cleaned.length > MAX_METADATA_TRANSCRIPT_CHARS ? cleaned.slice(0, MAX_METADATA_TRANSCRIPT_CHARS).trim() : cleaned;
	}

	cleanMetadataTranscriptVtt(value) {
		let cleaned = this.cleanMetadataText(value);
		if (!cleaned) {
			return "";
		}
		if (/-->/m.test(cleaned) && !/^WEBVTT/i.test(cleaned)) {
			cleaned = `WEBVTT\n\n${cleaned}`;
		}
		return cleaned.length > MAX_METADATA_TRANSCRIPT_VTT_CHARS ? cleaned.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS).trim() : cleaned;
	}

	isMetadataGenerationInProgress(field = "") {
		const current = `${this.state.metadataGeneratingField || ""}`;
		return field ? current === field : current !== "";
	}

	getMetadataResourcePath(resource = null) {
		return this.getDriveResourcePath(resource);
	}

	getMetadataResourceMediaType(resource = null) {
		const target = resource || this.state.metadataEditorTarget || this.resolveDriveSelectionResource();
		if (!target) {
			return "file";
		}
		if (typeof target.ext === "string" && target.ext.trim() !== "") {
			try {
				return getMediaType(target.ext) || "file";
			} catch (_err) {
				return "file";
			}
		}
		if (typeof this.props.propName === "string" && this.props.propName.trim() !== "") {
			const byProp = this.props.propName.trim().toLowerCase();
			if (["image", "video", "audio", "pdf", "backgroundaudio"].includes(byProp)) {
				return byProp === "backgroundaudio" ? "audio" : byProp;
			}
		}
		return "file";
	}

	getMetadataResourceS3Key(resource = null) {
		const path = this.getMetadataResourcePath(resource);
		if (!path) {
			return "";
		}
		const pathParts = path
			.trim()
			.replace(/^\/+/, "")
			.split("/")
			.filter(Boolean);
		if (pathParts.length < 2) {
			return path;
		}
		const rootSegment = pathParts[0];
		if (rootSegment !== "private" && rootSegment !== "public") {
			return path;
		}
		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[1] || "");
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				pathParts.splice(1, 0, orgId);
			}
		}
		return pathParts.join("/");
	}

	extractResponsesText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		if (typeof payload.output_text === "string" && payload.output_text.trim() !== "") {
			return payload.output_text;
		}
		if (payload.response && typeof payload.response.output_text === "string" && payload.response.output_text.trim() !== "") {
			return payload.response.output_text;
		}
		if (typeof payload.text === "string" && payload.text.trim() !== "") {
			return payload.text;
		}
		const readOutputArray = (arr) => {
			if (!Array.isArray(arr)) {
				return "";
			}
			const parts = [];
			arr.forEach((entry) => {
				if (!entry) {
					return;
				}
				if (entry.type === "message" && Array.isArray(entry.content)) {
					entry.content.forEach((contentPart) => {
						if (typeof contentPart?.text === "string" && contentPart.text.trim() !== "") {
							parts.push(contentPart.text);
						} else if (typeof contentPart?.value === "string" && contentPart.value.trim() !== "") {
							parts.push(contentPart.value);
						}
					});
					return;
				}
				if (typeof entry.text === "string" && entry.text.trim() !== "") {
					parts.push(entry.text);
				}
			});
			return parts.join("").trim();
		};
		return readOutputArray(payload.output || payload.response?.output);
	}

	async runMetadataResponsesPrompt(promptText = "") {
		const requestBody = {
			model: "gpt-5.4",
			input: [
				{
					role: "user",
					content: [{ type: "input_text", text: promptText }]
				}
			]
		};
		const payload = await getResponsesCreateLambda(JSON.stringify(requestBody), { showAlert: false });
		return this.extractResponsesText(payload);
	}

	buildMetadataGenerationContext() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const title = this.cleanMetadataTitle(this.state.metadataEditorTitle || "");
		const description = this.cleanMetadataDescription(this.state.metadataEditorDescription || "");
		const transcript = this.cleanMetadataTranscript(this.state.metadataEditorTranscript || "");
		const transcriptVtt = this.cleanMetadataTranscriptVtt(this.state.metadataEditorTranscriptVtt || "");
		const tags = this.mergeUniqueMetadataTags(this.state.metadataEditorPrimaryTags || []);
		const mediaType = this.getMetadataResourceMediaType(target);
		const path = this.getMetadataResourcePath(target);

		const contextParts = [
			`File name: ${target?.name || "(unknown)"}`,
			`Media type: ${mediaType}`,
			`Path: ${path || "(unknown)"}`,
			`Current title: ${title || "(none)"}`,
			`Current description: ${description || "(none)"}`,
			`Current transcript available: ${transcript ? "yes" : "no"}`,
			`Current timed transcript (VTT) available: ${transcriptVtt ? "yes" : "no"}`,
			`Current tags: ${tags.length ? tags.join(", ") : "(none)"}`
		];
		if (transcript) {
			const snippet = transcript.length > 2000 ? `${transcript.slice(0, 2000)}\n\n[Transcript truncated.]` : transcript;
			contextParts.push(`Transcript snippet:\n${snippet}`);
		}
		return contextParts.join("\n");
	}

	cleanGeneratedTagCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/^[-*•]\s+/, "")
			.replace(/^\d+\.\s+/, "")
			.replace(/^tags?\s*:\s*/i, "")
			.replace(/^["'`]+|["'`]+$/g, "")
			.replace(/\s+/g, " ")
			.trim();
		cleaned = cleaned.replace(/[;,.\-:]+$/g, "").trim();
		if (!cleaned || cleaned.length > 80) {
			return "";
		}
		return cleaned;
	}

	parseGeneratedTags(responseText = "") {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return [];
		}
		const tags = [];
		const addTags = (entries = []) => {
			entries.forEach((entry) => {
				const cleaned = this.cleanGeneratedTagCandidate(entry);
				if (cleaned) {
					tags.push(cleaned);
				}
			});
		};

		const normalizedText = responseText
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.trim();
		const lines = normalizedText.split("\n").map((line) => line.trim()).filter(Boolean);
		for (let i = 0; i < Math.min(lines.length, 12); i++) {
			const line = lines[i].replace(/^assistant:\s*/i, "").replace(/^tags?\s*:\s*/i, "");
			if (line.indexOf(",") > -1) {
				addTags(line.split(","));
				if (tags.length >= 3) {
					break;
				}
			}
		}
		if (!tags.length && lines.length) {
			addTags(lines[0].split(","));
		}
		return this.mergeUniqueMetadataTags(tags).slice(0, 25);
	}

	extractAwsTranscribeText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		const directText =
			payload.text ||
			payload.transcript ||
			payload.output_text ||
			payload.content ||
			payload?.results?.transcripts?.[0]?.transcript ||
			"";
		if (typeof directText === "string" && directText.trim() !== "") {
			return directText.trim();
		}
		return this.extractResponsesText(payload);
	}

	extractAwsTranscribeVtt(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return /-->/m.test(payload) ? payload : "";
		}
		const candidates = [payload.vtt, payload.transcriptVtt, payload.transcript_vtt, payload.output_vtt, payload.outputVtt, payload.text];
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			if (typeof candidate === "string" && /-->/m.test(candidate)) {
				return candidate;
			}
		}
		return "";
	}

	extractTranscriptFromVtt(vttValue = "") {
		const normalized = `${vttValue || ""}`.replace(/\r\n/g, "\n");
		if (!normalized.trim()) {
			return "";
		}
		const lines = normalized
			.split("\n")
			.map((line) => line.trim())
			.filter((line) => line !== "")
			.filter((line) => !/^WEBVTT$/i.test(line))
			.filter((line) => !/^NOTE\b/i.test(line))
			.filter((line) => !/^\d+$/.test(line))
			.filter((line) => !/^\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}\s+-->\s+\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}/.test(line));
		return lines.join(" ").replace(/\s+/g, " ").trim();
	}

	extractTagsFromRekognitionPayload(payload) {
		if (!payload) {
			return [];
		}
		if (typeof payload === "string") {
			return this.mergeUniqueMetadataTags(this.normalizeMetadataTagSource(payload));
		}
		const tags = [];
		const addTag = (value) => {
			const normalized = this.cleanGeneratedTagCandidate(`${value || ""}`);
			if (normalized) {
				tags.push(normalized);
			}
		};
		this.normalizeMetadataTagSource(payload.tags || []).forEach(addTag);
		this.normalizeMetadataTagSource(payload.rekognitionTags || []).forEach(addTag);
		this.normalizeMetadataTagSource(payload.openAiTags || []).forEach(addTag);
		(Array.isArray(payload.labels) ? payload.labels : []).forEach((labelEntry) => {
			if (typeof labelEntry === "string") {
				addTag(labelEntry);
			} else if (labelEntry && typeof labelEntry === "object") {
				addTag(labelEntry.Name || labelEntry.name);
			}
		});
		(Array.isArray(payload.Labels) ? payload.Labels : []).forEach((labelEntry) => {
			if (labelEntry && typeof labelEntry === "object") {
				addTag(labelEntry.Name || labelEntry.name);
			}
		});
		return this.mergeUniqueMetadataTags(tags).slice(0, 25);
	}

	handleChangeUrl(e) {
		this.handleChangeProperty(this.props.propName, e.target.value);
	}

	handlePaste() {
		if (!isClipboardEmpty()) {
			this.handleReplaceValue(getClipboard());
		}
	}

	onDocumentLoad(pdfInfo) {
		console.log("PDF loaded", pdfInfo);
		this.setState({
			pdfInfo
		});
	}
	handleQuickUpload(autoSelect = true) {
		const { accept } = this.props;
		let _accept = accept;
		if (!_accept) {
			_accept = "*/*";
		}
		const input = this.fileUploadField.current;
		if (input) {
			input.accept = _accept;
			input.click();
			this.setState({
				quickUploadAutoSelect: autoSelect
			});
		}
	}

	handleChangeProperty(propName, propValue) {
		if (this.props.onChange && _.isFunction(this.props.onChange)) {
			this.props.onChange(propValue);
		} else {
			this.props.dispatch(
				handleChangeProperty,
				propName,
				propValue
			);
		}
	}

	handleReplaceValue(newVal) {
		this.handleChangeProperty(this.props.propName, newVal);
	}

	handleReplaceExisting(path) {
		console.log("replace existing", path);
		const { accept } = this.props;
		let _accept = accept;
		if (!_accept) {
			_accept = "*/*";
		} else {
			_accept = _accept.replace("/*", "/" + _.last(path.split(".")));
		}
		const input = this.fileUploadField.current;
		if (input) {
			input.accept = _accept;
			input.click();
		}
		this.setState({
			replaceExistingTarget: path
		});
	}

	handleQuickUploadSubmit(event, overrides = {}) {
		const file = event.target.files[0];
		const nodePath = getSelectedNodePath();
		console.log("Got files", file, this.state.config);
		let fileName = (overrides.fileName) ? overrides.fileName : file.name;
		if (file && fileName) {
			const propName = overrides.propName || this.props.propName;
			const autoLink = overrides.hasOwnProperty("autoLink") ? overrides.autoLink : this.state.quickUploadAutoSelect;
			this.setState({
				uploading: true
			});
			const driveRootPath = getDriveRootPath(true);
			console.log(driveRootPath);
			const replaceExistingTarget = overrides.replaceExistingTarget || this.state.replaceExistingTarget;
			const isReplace = !!replaceExistingTarget;
			let targetPath = isReplace ? replaceExistingTarget : `private/activities/${driveRootPath}`;
			const isQuickMobileUpload = !isReplace && isMobile();
			if (isQuickMobileUpload) {
				let newExt;
				if (propName === "video") {
					newExt = "mp4";
				} else if (propName === "audio" || propName === "backgroundAudio") {
					newExt = "mp3";
				} else {
					newExt = `${_.last(fileName.split("."))}`;
				}

				targetPath = `${targetPath}/${generateUUID()}.${newExt}`;
			}

			const func = (isMediaOptimizationDisabled() || overrides.notOptimized) ? uploadFile : uploadAndOptimizeMediaFile;
			func(targetPath, file, propName, isReplace || isQuickMobileUpload, overrides).then((uploadResponse) => {
				if (autoLink) {
					const uploadedResource =
						(uploadResponse && uploadResponse.guid ? getDriveObject(uploadResponse.guid) : null) ||
						getDriveObjectByPath(uploadResponse.path, propName === "video");
					if (!uploadedResource) {
						throw new Error(`Upload succeeded but the new Drive object could not be resolved for ${uploadResponse.path || "uploaded file"}.`);
					}
					injectExternalResourceReference(propName, uploadedResource, nodePath);
				}
				this.setState({
					uploading: false,
					replaceExistingTarget: null
				});
				this.fileUploadField.current.value = "";

			}).catch(err => {
				showError("Upload File", "An error occurred while attempting to upload the file. Error: " + err);
			});
		} else {
			showError("Upload File", "Need to select a folder and specify a file to upload");
		}
	}

	handleShowGenerateTtsAudioForPropertyModal(propName) {
		this.props.dispatch(handleShowGenerateTtsAudioForPropertyModal, propName);
	}

	pasteFunction(event) {
		let self = this;
		// consider the first item (can be easily extended for multiple items)
		let item = event.pasteEvent.clipboardData.items[0];

		if (this.state.showPasteImageModal) {

			this.setState({
				showPasteImageModal: false
			});

			if (item && item.type.indexOf("image") === 0) {
				let blob = item.getAsFile();

				/*
				var reader = new FileReader();
				reader.onload = function (event) {
					console.log(event.target.result);				
				};
				reader.readAsDataURL(blob);
				*/

				let overrides = { notOptimized: true };

				if (event.imageName) {
					overrides.fileName = event.imageName;
				} else {
					overrides.fileName = generatePastedImageFileName();
				}

				self.handleQuickUploadSubmit({
					target: {
						files: [blob]
					}
				}, overrides);

			} else if (event.pasteEvent.clipboardData.files.length > 0) {

				let pastedFile = event.pasteEvent.clipboardData.files[0];

				let overrides = { notOptimized: true };

				if (event.imageName) {
					overrides.fileName = event.imageName;
				} else {
					overrides.fileName = generatePastedImageFileName(); //clipboard always returns png
				}

				if (pastedFile.type.indexOf("image") === 0) {
					self.handleQuickUploadSubmit({
						target: {
							files: [pastedFile]
						}
					}, overrides);
				}


			} else {
				console.log("Skipping paste for item", item);
				showError("Error", "Paste image failed, no image data found.");
			}
		}
	}

	handleShowPasteImageModal() {
		this.setState({
			showPasteImageModal: true,
			quickUploadAutoSelect: true //need to do this so inline file picker path is always updated
		});
	}

	handleShowAiImageGeneratorModal() {
		this.setState({
			showAiImageGeneratorModal: true
		});
	}

	handleShowImageEditorModal(targetPropName = null) {
		if (!this.isImageToolsEnabled()) {
			return;
		}

		if (!this.canEditCurrentImage()) {
			showError("Edit Image", "This item needs an image before it can be edited.");
			return;
		}

		this.setState({
			showImageEditorModal: true,
			imageEditorTargetPropName: targetPropName || this.props.propName,
			quickUploadAutoSelect: true
		});
	}

	handleShowVideoThumbnailModal(targetPropName = null) {
		if (!this.isImageToolsEnabled()) {
			return;
		}

		if (!this.canCreateVideoThumbnail()) {
			showError("Create Video Thumbnail", "This item needs a video before a thumbnail can be created.");
			return;
		}

		this.setState({
			showVideoThumbnailModal: true,
			videoThumbnailTargetPropName: targetPropName || this.props.videoThumbnailTargetPropName || this.props.propName,
			quickUploadAutoSelect: true
		});
	}

	handleClosePasteImageModal() {
		this.setState({
			showPasteImageModal: false
		});
	}


	handleCloseAiImageGeneratorModal() {
		this.setState({
			showAiImageGeneratorModal: false
		});
	}

	handleCloseImageEditorModal() {
		this.setState({
			showImageEditorModal: false,
			imageEditorTargetPropName: null
		});
	}

	handleCloseVideoThumbnailModal() {
		this.setState({
			showVideoThumbnailModal: false,
			videoThumbnailTargetPropName: null
		});
	}

	handleShowMarkupImageModal() {
		this.setState({
			showMarkupImageModal: true
		});
	}

	handleCloseMarkupImageModal() {
		this.setState({
			showMarkupImageModal: false
		});
	}

	handleCreateVideoThumbnail({ blob, imageName, autoLink = true }) {
		if (!blob) {
			showError("Create Video Thumbnail", "Unable to create thumbnail image.");
			return;
		}

		const targetPropName = this.state.videoThumbnailTargetPropName || this.props.videoThumbnailTargetPropName || this.props.propName;
		const safeFileName = `${imageName || "video-thumbnail.png"}`.trim() || "video-thumbnail.png";
		const file = new File([blob], safeFileName, { type: "image/png" });

		this.setState({
			showVideoThumbnailModal: false,
			videoThumbnailTargetPropName: null,
			quickUploadAutoSelect: !!autoLink
		});

		this.handleQuickUploadSubmit({
			target: {
				files: [file]
			}
		}, {
			fileName: safeFileName,
			propName: targetPropName,
			autoLink,
			notOptimized: true
		});
	}

	handleCreateEditedImage({ blob, imageName, autoLink = true, overwriteImage = false, overwriteTargetPath = "" }) {
		if (!blob) {
			showError("Edit Image", "Unable to save edited image.");
			return;
		}

		const targetPropName = this.state.imageEditorTargetPropName || this.props.propName;
		const safeFileName = `${imageName || "image-edited.png"}`.trim() || "image-edited.png";
		const file = new File([blob], safeFileName, { type: "image/png" });

		this.setState({
			showImageEditorModal: false,
			imageEditorTargetPropName: null,
			quickUploadAutoSelect: !!autoLink
		});

		this.handleQuickUploadSubmit({
			target: {
				files: [file]
			}
		}, {
			fileName: safeFileName,
			propName: targetPropName,
			autoLink,
			replaceExistingTarget: overwriteImage ? overwriteTargetPath : "",
			notOptimized: true
		});
	}

	renderMediaPanel(type, url, driveReference = true, selectedDriveResource = null) {
		let result = <div />;
		const { loading } = this.state;
		const loadingDiv = <div style={{ margin: "15px" }}><FontAwesomeIcon
			icon='spinner'
			spin /> Uploading media asset...</div>;
		const hasDriveFileIdentity =
			!!selectedDriveResource &&
			!!(
				selectedDriveResource.guid ||
				this.getDriveResourcePath(selectedDriveResource) ||
				selectedDriveResource.name
			);
		const isDriveAssetPreview = !driveReference && hasDriveFileIdentity && selectedDriveResource.type !== "folder";
		const mediaMetadata = this.getMediaMetadataForResource(selectedDriveResource);
		const hasMetadata = this.hasAnyMediaMetadata(mediaMetadata);


		let generateTtsAudioMenuItem;
		if (this.props.generateTtsAudio) {
			generateTtsAudioMenuItem = <MenuItem onClick={() => { this.handleShowGenerateTtsAudioForPropertyModal(type); }}><div><FontAwesomeIcon icon={["far", "volume-up"]} />&nbsp;Generate TTS Audio</div></MenuItem>;
		}


		let _createUrlWrapper = driveReference && !!url;
		if (loading) {
			result = loadingDiv;
		} else {
			switch (type) {
				case "video": {
					result = url ? <ReactPlayer url={url} className="player-video" width="100%" playing={false} playsInline={true} muted={false} loop controls /> : null;
					break;
				}
				case "audio":
				case "backgroundAudio":
				case "labelAudioFile":
				case "label1AudioFile":
				case "label2AudioFile":
				case "commentsAudioFile":
					{
						result = url ? <ReactAudioPlayer style={{ width: "100%", maxWidth: "400px" }} src={url} controls /> : null;
						break;
					}
				case "pdf": {
					if (url) {
						const _url = urlToSecureParameterObject(url);
						console.log("PDF fetch url", _url);
						// result = <iframe style={{width:"100%", height:"60.4vw"}} src={url} />;
						result = <div className="embed-responsive embed-responsive-210by297">
							<object className="embed-responsive-item" data={url} type="application/pdf" internalinstanceid="9" title="">
								<p>Your browser isn't supporting embedded pdf files. You can download the file
									<a href={url}> here</a>.</p>
							</object>
						</div>;
						// result = <Document
						// 	style={{width:"100%"}}	
						// 	file={_url}
						// 	onLoadSuccess={this.onDocumentLoad}
						// >
						// 	<Page pageNumber={1} scale={0.5} />
						// </Document>;
					}
					break;
				}
				case "threeD": {
					result = null;

					// result = url && validateUrl(url) ? <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
					// 	3D Preview will go here
					// </div> : null;
					break;
				}
				case "videoTextTrack": {
					result = null;

					// result = url && validateUrl(url) ? <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
					// 	Video Text Track Preview will go here
					// </div> : null;

					break;
				}
				default: {
					// result = url && validateUrl(url) ? <img alt="Preview" style={{ maxWidth: "800px" }} src={url} /> : null;

					let authorProperties = {};

					let cursor = state.select(state.select("selectedNodePath").get());
					let entity = cursor.get().entity;

					if (entity.authorProperties) {
						try {
							authorProperties = JSON.parse(entity.authorProperties);
						} catch (err) {
							authorProperties = {};
						}
					}

					// If have imageHotspots in authorProperties
					let imageHotspots = authorProperties.imageHotspots ? authorProperties.imageHotspots : null;

					let imagePreview = <ImageWithMarkup url={url} imageHotspots={imageHotspots} />;
					if (isDriveAssetPreview && this.state.showPreviewMetadataTitle && mediaMetadata.title) {
						imagePreview = (
							<div style={{ position: "relative", width: "fit-content", maxWidth: "100%" }}>
								{imagePreview}
								<div
									title={mediaMetadata.title}
									style={{
										position: "absolute",
										left: "10px",
										right: "10px",
										bottom: "10px",
										padding: "5px 10px",
										borderRadius: "8px",
										background: "rgba(7, 22, 43, 0.78)",
										color: "#ffffff",
										fontSize: "13px",
										fontWeight: 600,
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
										pointerEvents: "none"
									}}
								>
									{mediaMetadata.title}
								</div>
							</div>
						);
					}

					result = imagePreview;
				}
			}
		}
		if (_createUrlWrapper && result !== loadingDiv) {
			result = (
				<div>



					<FormGroup>
						<InputGroup>
							<FormControl onChange={(e) => { this.handleChangeUrl(e); }} type="text" value={url} ref={el => this[`ref-${type}`] = el} />
							<SplitButton
								componentClass={InputGroup.Button}
								id="input-dropdown-addon"
								title={<div onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon icon="clipboard" />&nbsp;Copy</div>}
								pullRight
							>
								<MenuItem disabled={isClipboardEmpty()} key="1" onClick={() => { this.handlePaste(type); }}><FontAwesomeIcon icon="paste" />&nbsp;Paste Resource</MenuItem>
								<MenuItem divider />
								{generateTtsAudioMenuItem}
								{(this.props.markupImage || (!this.state.mobile && (this.props.urlParams.hasOwnProperty("markupImage") && this.props.urlParams.markupImage === "true"))) &&
									<>
										<MenuItem key="markupImageModal" onClick={() => {
											this.handleShowMarkupImageModal();
										}}>
											<FontAwesomeIcon icon="pen" />&nbsp;Media Markup
										</MenuItem>
										<MenuItem divider />
									</>
								}
								<MenuItem key="1" onClick={() => { /*handleOpenInNewTab(url);*/ this.props.dispatch(showMediaPreviewModal, url, type); }}><FontAwesomeIcon icon="expand-wide" />&nbsp;View&nbsp;Media&nbsp;</MenuItem>
							</SplitButton>
						</InputGroup>
					</FormGroup>
					{result}
					{/* <MediaQuery query='(max-width: 599px)'>
						<div style={{ marginTop: "5px" }}><a href="#clip" onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon name="clipboard" />&nbsp;Copy&nbsp;Media&nbsp;Address</a></div><div style={{ marginTop: "5px" }}><a href={url} target="_blank"><FontAwesomeIcon icon="external-link"/>&nbsp;View&nbsp;Media</a></div>
					</MediaQuery>
					<MediaQuery query='(min-width: 600px)'>
						<div style={{ marginTop: "5px" }}><a href="#clip" onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon name="clipboard" />&nbsp;Copy&nbsp;Media&nbsp;Address</a> | <a href={url} target="_blank"><FontAwesomeIcon icon="external-link" />&nbsp;View&nbsp;Media</a></div>
					</MediaQuery>	 */}
				</div>
			);
		} else if (driveReference && result !== loadingDiv) {
			result = (<div>
				<FormGroup>
					<InputGroup>
						<FormControl onChange={(e) => { this.handleChangeUrl(e); }} type="text" value={url} ref={el => this[`ref-${type}`] = el} />
						<SplitButton
							componentClass={InputGroup.Button}
							id="input-dropdown-addon"
							title={<div onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon icon="clipboard" />&nbsp;Copy</div>}
							pullRight
						>
							<MenuItem disabled={isClipboardEmpty()} key="1" onClick={() => { this.handlePaste(type); }}><FontAwesomeIcon icon="paste" />&nbsp;Paste</MenuItem>
							{generateTtsAudioMenuItem}
							<MenuItem divider />
							<MenuItem key="2" onClick={() => { /*handleOpenInNewTab(url);*/ this.props.dispatch(showMediaPreviewModal, url, type); }}><FontAwesomeIcon icon="expand-wide" />&nbsp;View&nbsp;Media&nbsp;</MenuItem>
						</SplitButton>
					</InputGroup>
				</FormGroup>
			</div>);
		} else if (result !== loadingDiv) {
			result = (
				<div style={{ display: "flex", flexDirection: "column" }}>
					{result}
					<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
						{this.isImageToolsEnabled() && type === "video" && this.props.videoThumbnailTargetPropName && this.canCreateVideoThumbnail() &&
							<Button
								style={{ marginTop: "5px" }}
								onClick={() => { this.handleShowVideoThumbnailModal(this.props.videoThumbnailTargetPropName); }}
							>
								<FontAwesomeIcon icon="camera" />&nbsp;Create Video Thumbnail
							</Button>
						}
						{(type === "image" && (this.props.markupImage || (!this.state.mobile && (this.props.urlParams.hasOwnProperty("markupImage") && this.props.urlParams.markupImage === "true")))) &&
							<Button style={{ marginTop: "5px", marginRight: "10px" }} onClick={() => { this.handleShowMarkupImageModal(); }}><FontAwesomeIcon icon="pen" />&nbsp;Media&nbsp;Markup</Button>
						}
						{!this.state.mobile && <Button style={{ marginTop: "5px", maxWidth: "200px" }} onClick={() => { /*handleOpenInNewTab(url)*/ this.props.dispatch(showMediaPreviewModal, url, type); }}><FontAwesomeIcon icon="expand-wide" />&nbsp;View&nbsp;Media&nbsp;</Button>}
						{this.isImageToolsEnabled() && type === "image" && this.canEditCurrentImage() &&
							<Button style={{ marginTop: "5px" }} onClick={() => this.handleShowImageEditorModal(this.props.propName)}>
								<FontAwesomeIcon icon="edit" />&nbsp;Edit Image
							</Button>
						}
						{isDriveAssetPreview && this.isAiAssistantUiEnabled() &&
							<Button style={{ marginTop: "5px" }} onClick={() => this.handleUseInAiAssistant(selectedDriveResource)}>
								<FontAwesomeIcon icon="comment-alt" />&nbsp;Use in AI Assistant
							</Button>
						}
						{isDriveAssetPreview &&
							<Button style={{ marginTop: "5px" }} onClick={() => this.handleShowMetadataEditor(selectedDriveResource)}>
								<FontAwesomeIcon icon="edit" />&nbsp;Metadata
							</Button>
						}
						{isDriveAssetPreview &&
							<Button style={{ marginTop: "5px" }} onClick={this.handleToggleMediaMetadataPanel}>
								<FontAwesomeIcon icon="tags" />&nbsp;{this.state.showMediaMetadataPanel ? "Hide Metadata" : "Show Metadata"}
							</Button>
						}
					</div>
					{isDriveAssetPreview && this.state.showMediaMetadataPanel &&
						<div style={{ marginTop: "8px", padding: "10px", border: "1px solid #d8e1ee", borderRadius: "6px", backgroundColor: "#f8fbff" }}>
							<div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "8px" }}>
								<Button
									bsStyle={this.state.showPreviewMetadataTitle ? "primary" : "default"}
									bsSize="small"
									onClick={() => this.handleTogglePreviewMetadataField("title")}
								>
									{this.state.showPreviewMetadataTitle ? "Hide Title" : "Show Title"}
								</Button>
								<Button
									bsStyle={this.state.showPreviewMetadataDescription ? "primary" : "default"}
									bsSize="small"
									onClick={() => this.handleTogglePreviewMetadataField("description")}
								>
									{this.state.showPreviewMetadataDescription ? "Hide Description" : "Show Description"}
								</Button>
								<Button
									bsStyle={this.state.showPreviewMetadataTags ? "primary" : "default"}
									bsSize="small"
									onClick={() => this.handleTogglePreviewMetadataField("tags")}
								>
									{this.state.showPreviewMetadataTags ? "Hide Tags" : "Show Tags"}
								</Button>
							</div>
							{!hasMetadata &&
								<div style={{ color: "#6b7f95" }}>
									No metadata found for this file yet. Use metadata generate actions to create and save title, description, transcript, or tags.
								</div>
							}
							{this.state.showPreviewMetadataTitle && mediaMetadata.title &&
								<div style={{ marginBottom: "6px" }}>
									<b>Title:</b> {mediaMetadata.title}
								</div>
							}
							{this.state.showPreviewMetadataDescription && mediaMetadata.description &&
								<div style={{ marginBottom: "6px" }}>
									<b>Description:</b> {mediaMetadata.description}
								</div>
							}
							{this.state.showPreviewMetadataTags && mediaMetadata.tags.length > 0 &&
								<div style={{ display: "flex", alignItems: "flex-start", gap: "6px", flexWrap: "wrap" }}>
									<b style={{ marginTop: "4px" }}>Tags:</b>
									{mediaMetadata.tags.map((tag) => (
										<span
											key={`preview-metadata-tag-${selectedDriveResource?.guid || "resource"}-${tag}`}
											style={{
												backgroundColor: "#f1f3f4",
												color: "#333",
												padding: "4px 8px",
												borderRadius: "12px",
												fontSize: "12px",
												whiteSpace: "nowrap"
											}}
										>
											{tag}
										</span>
									))}
								</div>
							}
						</div>
					}
				</div>);
		}
		return result;
	}

	render() {

		const { value, propName, accept, label, entityId } = this.props;

		let authorProperties = {};

		let cursor = state.select(state.select("selectedNodePath").get());
		let entity = cursor.get().entity;

		if (entity.authorProperties) {
			try {
				authorProperties = JSON.parse(entity.authorProperties);
			} catch (err) {
				authorProperties = {};
			}
		}

		// If have imageHotspots in authorProperties
		let imageHotspots = authorProperties.imageHotspots ? authorProperties.imageHotspots : null;
		let imageKenBurnsEffect = authorProperties.imageKenBurnsEffect ? authorProperties.imageKenBurnsEffect : null;

		const driveReference = isDriveReference(value);
		let _accept = accept;
		if (!_accept) {
			_accept = "*/*";
		}
		let previewUrl = null;
		let externalResource = null;
		if (driveReference) {
			try {
				externalResource = this.getDriveResourceFromValue(value);
				previewUrl = externalResource ? getUrlForResource(externalResource, externalResource) : null;
				// if (previewUrl.includes(".vtt")) {
				// 	getContent(resourceEntry.guid).then(content => {
				// 		console.log("!@!@!@ CONTENT", content);
				// 	}).catch(err => {
				// 		showError("Get Content", "An error occurred while attempting to get content: " + err);
				// 	});
				// }
			} catch (err) {
				console.warn(err);
			}
		} else {
			previewUrl = value;
			externalResource = value;
		}

		console.log("Render a preview", previewUrl);
		const preview = this.renderMediaPanel(propName, previewUrl, !driveReference, externalResource);
		const imageToolsEnabled = this.isImageToolsEnabled();
		const metadataActionControlHeight = 34;
		const metadataActionButtonStyle = {
			height: `${metadataActionControlHeight}px`,
			minHeight: `${metadataActionControlHeight}px`,
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			whiteSpace: "nowrap",
			padding: "0 12px"
		};
		const metadataActionSelectStyle = {
			height: `${metadataActionControlHeight}px`,
			minHeight: `${metadataActionControlHeight}px`,
			marginBottom: "0px",
			paddingTop: "0px",
			paddingBottom: "0px",
			lineHeight: `${metadataActionControlHeight}px`
		};

		console.log("EXTERNAL RESOURCE", externalResource);

		const videoThumbnailSource = this.getAssociatedVideoThumbnailSource();
		const component = (driveReference) ? <InlineFilePicker handleReplaceValue={this.handleReplaceValue} handleQuickUpload={this.handleQuickUpload} handleReplaceExisting={this.handleReplaceExisting} actionBarTop edit onFileSelected={this.handleSelectFile} value={externalResource} reference={value} accept={accept} entityId={entityId} handleShowPasteImageModal={this.handleShowPasteImageModal} handleShowAiImageGeneratorModal={this.handleShowAiImageGeneratorModal} handleShowMarkupImageModal={this.handleShowMarkupImageModal} handleShowVideoThumbnailModal={this.handleShowVideoThumbnailModal} showCreateVideoThumbnail={imageToolsEnabled && this.props.propName === "image" && !!videoThumbnailSource} /> : null;

		let generateTtsAudioMenuItem;
		console.log("MEDIA INJECTOR", this.props);
		if (this.props.generateTtsAudio) {
			generateTtsAudioMenuItem = <>
				<MenuItem eventKey="3" disabled={!driveReference} onClick={() => { this.handleShowGenerateTtsAudioForPropertyModal(propName); }}><div><FontAwesomeIcon icon="volume-up" /> Generate TTS Audio</div><div><small>Generate audio from associated text.</small></div></MenuItem>
				<MenuItem divider />
			</>;
		}

		let pasteImageModal;

		if (this.state.showPasteImageModal) {
			pasteImageModal = <PasteImageModal open={this.state.showPasteImageModal} onPaste={this.pasteFunction} onClose={this.handleClosePasteImageModal} nodePath={getSelectedNodePath()} />;
		}

		let aiImageGeneratorModal;

		if (this.state.showAiImageGeneratorModal) {
			aiImageGeneratorModal = <AiImageGeneratorModal open={this.state.showAiImageGeneratorModal} onClose={this.handleCloseAiImageGeneratorModal} />;
		}

		let markupImageModal;
		if (this.state.showMarkupImageModal) {
			markupImageModal = <MarkupImageModal open={this.state.showMarkupImageModal} onClose={this.handleCloseMarkupImageModal} url={previewUrl} imageHotspots={imageHotspots} imageKenBurnsEffect={imageKenBurnsEffect} />;
		}

		let imageEditorModal;
		const imageEditorSource = this.getCurrentImageEditorSource();
		if (imageToolsEnabled && this.state.showImageEditorModal && imageEditorSource) {
			imageEditorModal = (
				<ImageEditorModal
					open={this.state.showImageEditorModal}
					onClose={this.handleCloseImageEditorModal}
					onCreate={this.handleCreateEditedImage}
					imageUrl={imageEditorSource.url}
					driveObjectGuid={imageEditorSource.driveObjectGuid}
					imageLabel={imageEditorSource.label}
					defaultBaseName={imageEditorSource.defaultBaseName}
					originalImageName={imageEditorSource.originalImageName}
					overwriteTargetPath={imageEditorSource.overwriteTargetPath}
				/>
			);
		}

		let videoThumbnailModal;
		if (imageToolsEnabled && this.state.showVideoThumbnailModal && videoThumbnailSource) {
			videoThumbnailModal = (
				<VideoThumbnailModal
					open={this.state.showVideoThumbnailModal}
					onClose={this.handleCloseVideoThumbnailModal}
					onCreate={this.handleCreateVideoThumbnail}
					videoUrl={videoThumbnailSource.url}
					videoLabel={videoThumbnailSource.label}
					defaultBaseName={videoThumbnailSource.defaultBaseName}
				/>
			);
		}

		let metadataEditorModal;
		if (this.state.showMetadataEditorModal) {
			metadataEditorModal = (
				<Modal open={this.state.showMetadataEditorModal} onClose={this.handleHideMetadataEditor} classNames={{ modal: "custom-modal" }} closeButton>
					<div>
						<h4>Metadata Editor</h4>
						<hr />
						<div className="map-modal-body-container">
							<div style={{ marginBottom: "10px", color: "#5f6f82" }}>
								Manage title, description, transcript text, and searchable tags for <b>{this.state.metadataEditorTarget?.name || "selected file"}</b>.
							</div>

							<FormGroup controlId="inline-metadata-title">
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
									<ControlLabel style={{ marginBottom: 0 }}>Title</ControlLabel>
									<Button
										style={metadataActionButtonStyle}
										onClick={this.handleGenerateMetadataTitle}
										disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
									>
										{this.isMetadataGenerationInProgress("title") ? "Generating..." : "Generate Title"}
									</Button>
								</div>
								<FormControl
									type="text"
									placeholder="Short display/search title"
									value={this.state.metadataEditorTitle}
									onChange={this.handleMetadataEditorTitleChange}
								/>
								<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
									{(this.state.metadataEditorTitle || "").length}/{MAX_METADATA_TITLE_CHARS}
								</div>
							</FormGroup>

							<FormGroup controlId="inline-metadata-description">
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
									<ControlLabel style={{ marginBottom: 0 }}>Description</ControlLabel>
									<Button
										style={metadataActionButtonStyle}
										onClick={this.handleGenerateMetadataDescription}
										disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
									>
										{this.isMetadataGenerationInProgress("description") ? "Generating..." : "Generate Description"}
									</Button>
								</div>
								<FormControl
									componentClass="textarea"
									rows={3}
									placeholder="Concise description for search/discovery"
									value={this.state.metadataEditorDescription}
									onChange={this.handleMetadataEditorDescriptionChange}
								/>
								<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
									{(this.state.metadataEditorDescription || "").length}/{MAX_METADATA_DESCRIPTION_CHARS}
								</div>
							</FormGroup>

							<FormGroup controlId="inline-metadata-transcript">
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", gap: "8px", flexWrap: "wrap" }}>
									<ControlLabel style={{ marginBottom: 0 }}>Transcript / Content Text</ControlLabel>
									<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
										<FormControl
											componentClass="select"
											value={this.state.metadataTranscriptProvider}
											onChange={this.handleMetadataTranscriptProviderChange}
											disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
											style={{ width: "180px", ...metadataActionSelectStyle }}
										>
											<option value={TRANSCRIPT_PROVIDER_OPENAI}>OpenAI</option>
											<option value={TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE}>AWS Transcribe</option>
										</FormControl>
										<Button
											style={metadataActionButtonStyle}
											onClick={this.handleGenerateMetadataTranscript}
											disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
										>
											{this.isMetadataGenerationInProgress("transcript") ? "Generating..." : "Generate Transcript"}
										</Button>
										<Button
											style={metadataActionButtonStyle}
											onClick={this.handleGenerateMetadataTranscriptVtt}
											disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
										>
											{this.isMetadataGenerationInProgress("transcriptVtt") ? "Generating..." : "Generate VTT"}
										</Button>
									</div>
								</div>
								<FormControl
									componentClass="textarea"
									rows={5}
									placeholder="Long-form text representation (transcript, narration, image content notes, etc.)"
									value={this.state.metadataEditorTranscript}
									onChange={this.handleMetadataEditorTranscriptChange}
								/>
								<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
									{(this.state.metadataEditorTranscript || "").length}/{MAX_METADATA_TRANSCRIPT_CHARS}
								</div>
							</FormGroup>

							<FormGroup controlId="inline-metadata-vtt">
								<ControlLabel>Timed Transcript (VTT)</ControlLabel>
								<FormControl
									componentClass="textarea"
									rows={6}
									placeholder="WEBVTT content for timed captions/subtitles."
									value={this.state.metadataEditorTranscriptVtt}
									onChange={this.handleMetadataEditorTranscriptVttChange}
								/>
								<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
									{(this.state.metadataEditorTranscriptVtt || "").length}/{MAX_METADATA_TRANSCRIPT_VTT_CHARS}
								</div>
							</FormGroup>

							<FormGroup controlId="inline-metadata-tags-provider">
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
									<ControlLabel style={{ marginBottom: 0 }}>Tags</ControlLabel>
									<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
										<FormControl
											componentClass="select"
											value={this.state.metadataTagsProvider}
											onChange={this.handleMetadataTagsProviderChange}
											disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
											style={{ width: "190px", ...metadataActionSelectStyle }}
										>
											<option value={TAGS_PROVIDER_OPENAI}>OpenAI</option>
											<option value={TAGS_PROVIDER_REKOGNITION}>AWS Rekognition</option>
										</FormControl>
										<Button
											style={metadataActionButtonStyle}
											onClick={this.handleGenerateMetadataTags}
											disabled={this.isMetadataGenerationInProgress() || this.state.metadataEditorSaving}
										>
											{this.isMetadataGenerationInProgress("tags") ? "Generating..." : "Generate Tags"}
										</Button>
									</div>
								</div>
							</FormGroup>

							<FormGroup controlId="inline-metadata-add-tags">
								<ControlLabel>Add Primary Tags</ControlLabel>
								<div style={{ display: "flex", gap: "8px" }}>
									<FormControl
										type="text"
										placeholder="Add one or more tags (comma separated)"
										value={this.state.metadataEditorTagsInput}
										onChange={this.handleMetadataEditorTagsInputChange}
										onKeyDown={(event) => {
											if (event.key === "Enter") {
												event.preventDefault();
												this.handleAddMetadataEditorInputTags();
											}
										}}
									/>
									<Button
										bsStyle="primary"
										style={metadataActionButtonStyle}
										onClick={this.handleAddMetadataEditorInputTags}
										disabled={this.state.metadataEditorSaving || this.isMetadataGenerationInProgress()}
									>
										Add
									</Button>
								</div>
							</FormGroup>

							<div style={{ marginTop: "10px" }}>
								<ControlLabel>Primary Tags</ControlLabel>
								{this.state.metadataEditorPrimaryTags.length === 0 ? (
									<div style={{ color: "#8b97a6" }}><i>No primary tags yet.</i></div>
								) : (
									<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
										{this.state.metadataEditorPrimaryTags.map((tag) => (
											<span
												key={`inline-primary-${tag}`}
												style={{
													display: "inline-flex",
													alignItems: "center",
													gap: "6px",
													padding: "4px 8px",
													borderRadius: "999px",
													backgroundColor: "#e9f3ff",
													color: "#1f4d88",
													fontSize: "12px"
												}}
											>
												{tag}
												<Button
													bsSize="xsmall"
													onClick={() => this.handleRemoveMetadataEditorPrimaryTag(tag)}
													style={{ lineHeight: "1", padding: "1px 5px" }}
												>
													×
												</Button>
											</span>
										))}
									</div>
								)}
							</div>

							<div style={{ marginTop: "16px" }}>
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
									<ControlLabel style={{ marginBottom: 0 }}>Secondary Suggested Tags</ControlLabel>
									<Button
										style={metadataActionButtonStyle}
										onClick={this.handlePromoteAllMetadataEditorSecondaryTags}
										disabled={this.state.metadataEditorSecondaryTags.length === 0 || this.isMetadataGenerationInProgress()}
									>
										Promote All
									</Button>
								</div>
								{this.state.metadataEditorSecondaryTags.length === 0 ? (
									<div style={{ color: "#8b97a6" }}><i>No secondary tags found.</i></div>
								) : (
									<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
										{this.state.metadataEditorSecondaryTags.map((tag) => (
											<Button
												key={`inline-secondary-${tag}`}
												bsSize="small"
												onClick={() => this.handlePromoteMetadataEditorSecondaryTag(tag)}
												style={{
													borderRadius: "999px",
													padding: "4px 10px",
													backgroundColor: "#f5f7fa",
													border: "1px solid #d8dee8",
													color: "#34495e"
												}}
											>
												+ {tag}
											</Button>
										))}
									</div>
								)}
							</div>
						</div>
						<div className="modal-footer-container">
							<Button onClick={this.handleHideMetadataEditor} style={{ ...metadataActionButtonStyle, marginRight: "10px" }}>
								Cancel
							</Button>
							<Button
								bsStyle="primary"
								style={metadataActionButtonStyle}
								onClick={this.handleSaveMetadataEditor}
								disabled={this.state.metadataEditorSaving || this.isMetadataGenerationInProgress()}
							>
								{this.state.metadataEditorSaving ? "Saving..." : "Save Metadata"}
							</Button>
						</div>
					</div>
				</Modal>
			);
		}

		return (
			<AmbifiLoader show={this.state.uploading}>
				<div>
					<div>
						<label>{label}</label>
						{/* <Connected>
								<br/><span style={{ color: "red", fontWeight: "bold" }}><FontAwesomeIcon icon="exclamation-triangle " /> No Connection, upload may fail, make sure to  </span>
							</Connected> */}
					</div>
					<div style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", borderBottom: "1px dashed gray", paddingBottom: "10px" }}>
						<input ref={this.fileUploadField} type="file" id={`quick-upload-inline-${entityId}`} onChange={this.handleQuickUploadSubmit} style={{ display: "none" }} />
						<DropdownButton
							id={`${entityId}-reference-type-selector`}
							title={
								driveReference ? (
									<span><FontAwesomeIcon icon={["far", "hdd"]} /> From AmbiFi Drive</span>
								) : (
									<span><FontAwesomeIcon icon="external-link" /> From External (Self Hosted)</span>
								)
							}
						>
							<MenuItem eventKey="1" disabled={driveReference} onClick={() => { this.handleSwitchMode("drive"); }}><div><FontAwesomeIcon icon={["far", "hdd"]} /> Drive</div><div><small>Upload and reference files from your AmbiFi Drive.</small></div></MenuItem>
							<MenuItem eventKey="2" disabled={!driveReference} onClick={() => { this.handleSwitchMode("url"); }}><div><FontAwesomeIcon icon="external-link" /> External (Self Hosted)</div><div><small>Provide a URL to external files.</small></div></MenuItem>
							{generateTtsAudioMenuItem}
						</DropdownButton>
						<Button bsStyle="danger" onClick={this.handleDeleteMediaProperty}><FontAwesomeIcon icon="times" /></Button>
					</div>
					<div style={{ display: "flex", flexDirection: "column" }}>

						{component}
						{preview}
						<hr />
					</div>
					{pasteImageModal}
					{aiImageGeneratorModal}
					{markupImageModal}
					{imageEditorModal}
					{videoThumbnailModal}
					{metadataEditorModal}
				</div>
			</AmbifiLoader>
		);
	}

}


export default branch((props) => {
	return {
		guidToResource: ["drive", "guidToResource"],
		uploadStatus: ["uploads", props.entityId],
		urlParams: ["appState", "urlParams"],
		markupImage: ["appCapabilities", "markupImage"]
	};
}, MediaPropertyInjector);
